import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ItemDarioush from 'common/components/item/ItemDarioush';
import { dateFormatNoTimeZone } from 'common/helpers/dateHelper';
import { listProducts } from 'redux/products/actions';

const ManualItems = (props) => {
  const { clubMembership } = props;

  const dispatch = useDispatch();
  const { club } = clubMembership;
  const settings = useSelector((state) => state.setting);

  const products = useSelector((state) => state.product.data);

  let productIds = ``;

  if (clubMembership) {
    clubMembership.manualItems.forEach((item) => {
      const clubItem = club.controlledSubscription.items.find(
        (i) => i.sku === item.sku
      );
      if (clubItem) {
        if (productIds.length === 0) {
          productIds += clubItem.productId;
        } else {
          productIds += `,${clubItem.productId}`;
        }
      }
    });
  }

  useEffect(() => {
    if (productIds.length > 0) {
      dispatch(listProducts(null, `&ids=${productIds}`));
    }
  }, [dispatch, productIds]);

  if (clubMembership.manualItems.length === 0) {
    return null;
  }

  return (
    <div className="c7-account c7-manual-items">
      <h3>Regular Membership Items</h3>
      <div className="c7-cart-items c7-cart-items--club-shipment">
        {clubMembership.manualItems.map((item) => {
          const newItem = item;
          const clubItem = club.controlledSubscription.items.find(
            (i) => i.sku === item.sku
          );

          if (!clubItem) {
            return null;
          }

          newItem.productTitle = clubItem.productTitle;
          newItem.productVariant = clubItem.productVariant;
          newItem.price = clubItem.price;
          newItem.image = clubItem.image;

          if (products) {
            const product = products[clubItem.productId];
            if (product) {
              const { metaData } = product;
              if (metaData && metaData['club-release-date']) {
                newItem.shipDate = dateFormatNoTimeZone(
                  metaData['club-release-date'],
                  'darioush'
                );
              }
            }
          }

          return (
            <ItemDarioush item={newItem} key={item.id} settings={settings} />
          );
        })}
      </div>
    </div>
  );
};

export default ManualItems;
